import axios from "axios";

export const get = (endPoint, headers, encrypted, token) => {
    return axios.get(endPoint, {headers});
};
